import * as firebase from 'firebase/app';
import 'firebase/performance'
import 'firebase/analytics'
import 'firebase/auth'
import 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyDvi2bO7YRLFzbUu7BF8UCVqeOo4UF3dJ8",
    authDomain: "jobtojob-c9b04.firebaseapp.com",
    databaseURL: "https://jobtojob-c9b04.firebaseio.com",
    projectId: "jobtojob-c9b04",
    storageBucket: "jobtojob-c9b04.appspot.com",
    messagingSenderId: "557881072880",
    appId: "1:557881072880:web:9be0eea58505745d737635",
    measurementId: "G-12DJN7XN57"
};

firebase.initializeApp(firebaseConfig);
firebase.performance();
firebase.analytics();
firebase.auth().languageCode = 'it';
